export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./games-list.vue?vue&type=template&id=189e257a"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/games-list/games-list.vue?vue&type=template&id=189e257a
// module id = ycfi
// module chunks = 0